import { RouteConfig } from "vue-router";

const routes: Array<RouteConfig> = [
  {
    path: "/customers",
    name: "menu.customers",
    component: () => import("./index.vue"),
    meta: { isAuth: true, title: "POSRocket | Customers" },
  },
];

export default routes;
